import {
  ActiveSessionsCard,
  RepairsRequiredCard,
  MobileDashboardStatsCard,
} from '../../features/dashboard';
import { Category, Section } from './galleryPrimitives';

const SESSIONS = [
  { id: 's1', siteName: 'Banora Point High School', meta: 'Electrical · Started 20 Apr 2026' },
  { id: 's2', siteName: 'Banora Point Primary School', meta: 'Electrical · Started 22 Apr 2026' },
];

const REPAIR_SITES = [
  { id: 1, name: 'Tumbulgum Public School', location: 'Murwillumbah, NSW', repairCount: 10 },
  { id: 2, name: 'Pottsville Beach PS', location: 'Pottsville, NSW', repairCount: 3 },
  { id: 3, name: 'St Lucia Community Centre', location: 'St Lucia, QLD', repairCount: 1 },
];

/** Dashboard — section-card tables and the mobile due-stats card. */
export default function DashboardGallery() {
  return (
    <Category id="dashboard" title="Dashboard">
      <Section name="Dashboard Tables" file="components/ui/SectionCard.jsx · features/dashboard">
        <div style={{ display: 'grid', gap: '1rem', gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))' }}>
          <ActiveSessionsCard
            number="02"
            sessions={SESSIONS}
            onResume={(s) => window.alert(`Resume ${s.siteName}`)}
          />
          <RepairsRequiredCard
            number="03"
            sites={REPAIR_SITES}
            onRepair={(s) => window.alert(`Repair ${s.name}`)}
          />
          <ActiveSessionsCard number="04" sessions={[]} />
          <RepairsRequiredCard number="05" sites={[]} />
        </div>
      </Section>

      <Section name="MobileDashboardStatsCard" file="features/dashboard/components/MobileDashboardStatsCard.jsx">
        <div style={{ maxWidth: 360 }}>
          <MobileDashboardStatsCard sitesDue={8} repairsDue={14} />
        </div>
      </Section>
    </Category>
  );
}
